import { Descriptions, Modal, Button } from "antd";
import parse from "html-react-parser";

import { copyTextToClipboard } from "../../../../utils/clipboardHelper";
import { showErrorNotification, showSuccessNotification } from "../../../../utils/notification";

const ViewDetailsModal = ({
  campaignDetails = {},
  isModalOpen = false,
  setIsModalOpen = () => {}
}) => {
  const { emailHtmlContent = "", emailSubject = "", campaignDescription = "" } = campaignDetails;
  const reactElement = parse(emailHtmlContent);

  const handleCopyHtml = async () => {
    const hasCopied = await copyTextToClipboard(emailHtmlContent);
    if (!hasCopied) {
      showErrorNotification("Failed to copy HTML content.");
      return;
    }
    showSuccessNotification("HTML content copied to clipboard!");
  };

  return (
    <Modal
      title="View Content"
      centered
      width={"1200px"}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <>
        <Descriptions title="Campaign Details" bordered column={{ xs: 1, sm: 2, md: 3 }}>
          <Descriptions.Item label="Description">{campaignDescription}</Descriptions.Item>
          <Descriptions.Item label="Subject">{emailSubject}</Descriptions.Item>
          <Descriptions.Item label="Actions">
            <Button onClick={handleCopyHtml} type="">
              Copy HTML
            </Button>
          </Descriptions.Item>
        </Descriptions>
        <h2>Email Content: </h2>
        {reactElement}
      </>
    </Modal>
  );
};
export default ViewDetailsModal;
